module.exports = __webpack_public_path__ + "static/logo-a3e3ef625c379132f3128855c89756ee.svg";